module.exports = __webpack_public_path__ + "static/media/2.89a33a83.png";